import React from 'react';
import { Lock } from 'lucide-react';
import TopBar from './common/TopBar';
import Footer from './common/Footer';
import Playground from './common/Playground';

// --------------------------- Main Component ----------------------------------
const PlaygroundContent: React.FC = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-amber-50 via-orange-50 to-white text-slate-800">
      <TopBar />

      {/* Playground */}
      <Playground {...{ height: 'calc( 100vh - 22rem )' }} />

      {/* Pricing / CTA */}
      <section id="pricing" className="py-16">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="rounded-2xl border border-amber-300 bg-gradient-to-br from-orange-50 to-amber-50 p-6 shadow-sm">
            <h3 className="text-xl font-semibold">API Access <span className="ml-2 inline-flex items-center rounded-md bg-orange-100 px-2 py-0.5 text-xs font-semibold text-orange-700">Subscription</span></h3>
            <p className="mt-2 text-slate-700">Integrate at scale with rate limits, auth tokens, and SLAs.</p>
            <ul className="mt-4 space-y-2 text-sm text-slate-700 list-disc pl-5">
              <li>POST <span className="font-mono">/v1/flatten</span> with raw JSON</li>
              <li>Deterministic keys for ETL/ELT</li>
              <li>99.9% uptime • Priority support</li>
            </ul>
            <div className="mt-4 rounded-xl border border-amber-200 bg-white p-4">
              <div className="text-xs font-semibold text-slate-500 mb-2">Example request</div>
              <pre className="overflow-auto rounded-lg bg-slate-900 p-3 text-amber-100 text-xs">
{`curl -X POST https://api.flatjson.com/v1/flatten \\
-H "Authorization: Bearer <API_KEY>" \\
-H "Content-Type: application/json" \\
-d '{"user":{"name':'Sinta","emails":["a@x","b@y"]}}'`}
                </pre>
            </div>
            <a href="#" className="mt-6 inline-flex items-center gap-2 rounded-xl bg-gradient-to-r from-orange-500 to-amber-400 px-4 py-2 text-white shadow">
              <Lock className="h-4 w-4"/> Get API key
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default PlaygroundContent;
